[
  {
    "cancel": "synchronous",
    "completion": "sync",
    "effects": "read",
    "errors": ["unauthorized", "not_found", "forbidden", "gated", "conflict", "bad_request"],
    "fee": "free",
    "id": "brand.read",
    "input_schema": {
      "additionalProperties": false,
      "properties": {},
      "type": "object"
    },
    "label": ["Read brand and facts", "读取品牌与事实"],
    "output_schema": {
      "additionalProperties": false,
      "properties": {
        "domains": {
          "items": {
            "type": "string"
          },
          "type": "array"
        },
        "facts": {
          "items": {
            "type": "object"
          },
          "type": "array"
        },
        "name": {
          "type": "string"
        }
      },
      "required": ["name", "domains", "facts"],
      "type": "object"
    },
    "permission": "read",
    "requirements": {
      "locale": "not_applicable",
      "period": "not_applicable",
      "prerequisites": [
        {
          "code": "permission",
          "label": ["Current brand read access is required.", "需要当前品牌的读取权限。"],
          "remedies": ["human"]
        }
      ],
      "scope": "current_brand",
      "sources": "scoped_database"
    },
    "retry": {
      "backoff_seconds": 0,
      "max_attempts": 1
    },
    "stall_seconds": 600,
    "storage": "entities.datapoints",
    "version": 1
  },
  {
    "cancel": "synchronous",
    "completion": "job",
    "effects": "write",
    "errors": ["unauthorized", "not_found", "forbidden", "gated", "conflict", "bad_request"],
    "fee": "metered",
    "id": "media.generate",
    "input_schema": {
      "additionalProperties": false,
      "properties": {
        "modality": {
          "enum": ["image", "speech", "video"],
          "type": "string"
        },
        "model": {
          "type": "string"
        },
        "params": {
          "description": "Model-specific knobs (resolution, quality, generate_audio, seed, …); keys and allowed values are the model's `params` in media.models",
          "type": "object"
        },
        "preset": {
          "enum": ["square", "portrait", "vertical", "landscape"],
          "type": "string"
        },
        "prompt": {
          "maxLength": 4000,
          "minLength": 1,
          "type": "string"
        },
        "seconds": {
          "maximum": 60,
          "minimum": 1,
          "type": "integer"
        },
        "session_id": {
          "type": "string"
        },
        "voice": {
          "type": "string"
        }
      },
      "required": ["modality", "model", "prompt", "preset"],
      "type": "object"
    },
    "label": ["Generate an image, clip or narration", "生成图片、视频或配音"],
    "output_schema": {
      "additionalProperties": false,
      "properties": {
        "file": {
          "properties": {
            "content_type": {
              "type": "string"
            },
            "id": {
              "type": "string"
            },
            "name": {
              "type": "string"
            }
          },
          "type": "object"
        }
      },
      "required": ["file"],
      "type": "object"
    },
    "permission": "brand_edit",
    "requirements": {
      "locale": "not_applicable",
      "period": "not_applicable",
      "prerequisites": [
        {
          "code": "permission",
          "label": ["Current brand editor access is required.", "需要当前品牌的编辑权限。"],
          "remedies": ["human"]
        },
        {
          "code": "operable",
          "label": ["The account must permit business changes.", "账户需处于可操作状态。"],
          "remedies": ["human"]
        },
        {
          "code": "credits",
          "label": [
            "Available credits and the run ceiling must cover the next model reservation.",
            "可用积分与运行上限须足以预留下一次模型调用费用。"
          ],
          "remedies": ["human"]
        }
      ],
      "scope": "current_brand",
      "sources": "scoped_database"
    },
    "retry": {
      "backoff_seconds": 0,
      "max_attempts": 1
    },
    "stall_seconds": 900,
    "storage": "files, agent_files",
    "version": 1
  },
  {
    "cancel": "synchronous",
    "completion": "sync",
    "effects": "read",
    "errors": ["unauthorized", "not_found", "forbidden", "gated", "conflict", "bad_request"],
    "fee": "free",
    "id": "media.models",
    "input_schema": {
      "additionalProperties": false,
      "properties": {},
      "required": [],
      "type": "object"
    },
    "label": ["List media models", "读取素材模型"],
    "output_schema": {
      "type": "object"
    },
    "permission": "read",
    "requirements": {
      "locale": "not_applicable",
      "period": "not_applicable",
      "prerequisites": [
        {
          "code": "permission",
          "label": ["Current brand read access is required.", "需要当前品牌的读取权限。"],
          "remedies": ["human"]
        }
      ],
      "scope": "current_brand",
      "sources": "scoped_database"
    },
    "retry": {
      "backoff_seconds": 0,
      "max_attempts": 1
    },
    "stall_seconds": 600,
    "storage": "files, agent_files",
    "version": 1
  },
  {
    "cancel": "synchronous",
    "completion": "sync",
    "effects": "write",
    "errors": ["unauthorized", "not_found", "forbidden", "gated", "conflict", "bad_request"],
    "fee": "free",
    "id": "page.adapt",
    "input_schema": {
      "additionalProperties": false,
      "properties": {
        "page_id": {
          "type": "string"
        },
        "platforms": {
          "items": {
            "type": "string",
            "description": "A platform id, or platform:format for one of its kinds of post (xiaohongshu:video)"
          },
          "maxItems": 50,
          "minItems": 1,
          "type": "array"
        }
      },
      "required": ["page_id", "platforms"],
      "type": "object"
    },
    "label": ["Adapt a page for platforms", "按平台适配文章"],
    "output_schema": {
      "additionalProperties": false,
      "properties": {
        "variants": {
          "items": {
            "type": "object"
          },
          "type": "array"
        }
      },
      "required": ["variants"],
      "type": "object"
    },
    "permission": "brand_edit",
    "requirements": {
      "locale": "not_applicable",
      "period": "not_applicable",
      "prerequisites": [
        {
          "code": "permission",
          "label": ["Current brand editor access is required.", "需要当前品牌的编辑权限。"],
          "remedies": ["human"]
        },
        {
          "code": "operable",
          "label": ["The account must permit business changes.", "账户需处于可操作状态。"],
          "remedies": ["human"]
        }
      ],
      "scope": "current_brand",
      "sources": "scoped_database"
    },
    "retry": {
      "backoff_seconds": 0,
      "max_attempts": 1
    },
    "stall_seconds": 600,
    "storage": "page_variants",
    "version": 1
  },
  {
    "cancel": "synchronous",
    "completion": "sync",
    "effects": "read",
    "errors": ["unauthorized", "not_found", "forbidden", "gated", "conflict", "bad_request"],
    "fee": "free",
    "id": "loop.read",
    "input_schema": {
      "additionalProperties": false,
      "properties": {
        "after_id": {
          "type": "string"
        },
        "locale": {
          "type": "string"
        },
        "section": {
          "enum": ["gaps", "pages", "claims"],
          "type": "string"
        }
      },
      "required": ["locale", "section"],
      "type": "object"
    },
    "label": ["Read linked loop records", "读取优化闭环记录"],
    "output_schema": {
      "additionalProperties": false,
      "properties": {
        "items": {
          "items": {
            "type": "object"
          },
          "type": "array"
        },
        "next_after_id": {
          "type": "string"
        }
      },
      "required": ["items"],
      "type": "object"
    },
    "permission": "read",
    "requirements": {
      "locale": "not_applicable",
      "period": "not_applicable",
      "prerequisites": [
        {
          "code": "permission",
          "label": ["Current brand read access is required.", "需要当前品牌的读取权限。"],
          "remedies": ["human"]
        }
      ],
      "scope": "current_brand",
      "sources": "scoped_database"
    },
    "retry": {
      "backoff_seconds": 0,
      "max_attempts": 1
    },
    "stall_seconds": 600,
    "storage": "gaps, pages, claims",
    "version": 1
  },
  {
    "cancel": "synchronous",
    "completion": "sync",
    "effects": "write",
    "errors": ["unauthorized", "not_found", "forbidden", "gated", "conflict", "bad_request"],
    "fee": "free",
    "id": "optimization.inspect",
    "input_schema": {
      "additionalProperties": false,
      "properties": {
        "locale": {
          "type": "string"
        }
      },
      "required": ["locale"],
      "type": "object"
    },
    "label": ["Review ongoing optimization", "检查优化事项进度"],
    "output_schema": {
      "additionalProperties": false,
      "properties": {
        "changed": {
          "items": {
            "type": "object"
          },
          "type": "array"
        },
        "items": {
          "items": {
            "type": "object"
          },
          "type": "array"
        },
        "unplanned": {
          "items": {
            "type": "object"
          },
          "type": "array"
        }
      },
      "required": ["items", "changed", "unplanned"],
      "type": "object"
    },
    "permission": "brand_edit",
    "requirements": {
      "locale": "not_applicable",
      "period": "not_applicable",
      "prerequisites": [
        {
          "code": "permission",
          "label": ["Current brand editor access is required.", "需要当前品牌的编辑权限。"],
          "remedies": ["human"]
        },
        {
          "code": "operable",
          "label": ["The account must permit business changes.", "账户需处于可操作状态。"],
          "remedies": ["human"]
        }
      ],
      "scope": "current_brand",
      "sources": "scoped_database"
    },
    "retry": {
      "backoff_seconds": 0,
      "max_attempts": 1
    },
    "stall_seconds": 600,
    "storage": "optimization_followups, pages, gaps, distribution_posts, platform_publish_tasks, reflows",
    "version": 1
  },
  {
    "cancel": "synchronous",
    "completion": "sync",
    "effects": "read",
    "errors": ["unauthorized", "not_found", "forbidden", "gated", "conflict", "bad_request"],
    "fee": "free",
    "id": "template.evidence",
    "input_schema": {
      "additionalProperties": false,
      "properties": {
        "locale": {
          "type": "string"
        },
        "operation": {
          "enum": [
            "citation_pages",
            "visibility_score",
            "citation_share",
            "prompt_responses",
            "factcheck_citation_analysis",
            "citation_sentiment_analysis"
          ],
          "type": "string"
        },
        "parameters": {
          "type": "object"
        }
      },
      "required": ["locale", "operation", "parameters"],
      "type": "object"
    },
    "label": ["Read scoped workflow evidence", "读取工作流范围内的证据"],
    "output_schema": {
      "additionalProperties": false,
      "properties": {
        "data": {}
      },
      "required": ["data"],
      "type": "object"
    },
    "permission": "read",
    "requirements": {
      "locale": "input_locale",
      "period": "input_window",
      "prerequisites": [
        {
          "code": "permission",
          "label": ["Current brand read access is required.", "需要当前品牌的读取权限。"],
          "remedies": ["human"]
        }
      ],
      "scope": "current_brand",
      "sources": "canonical_measurements"
    },
    "retry": {
      "backoff_seconds": 0,
      "max_attempts": 1
    },
    "stall_seconds": 600,
    "storage": "samples, sample_mentions, sample_citations, claims",
    "version": 1
  },
  {
    "cancel": "synchronous",
    "completion": "sync",
    "effects": "read",
    "errors": ["unauthorized", "not_found", "forbidden", "gated", "conflict", "bad_request"],
    "fee": "free",
    "id": "report.evidence",
    "input_schema": {
      "additionalProperties": false,
      "properties": {
        "days": {
          "maximum": 365,
          "minimum": 1,
          "type": "integer"
        },
        "engine": {
          "type": "string"
        },
        "intent": {
          "type": "string"
        },
        "locale": {
          "type": "string"
        },
        "topics": {
          "items": {
            "type": "string"
          },
          "maxItems": 100,
          "type": "array"
        }
      },
      "required": ["locale", "days"],
      "type": "object"
    },
    "label": ["Read report metrics, platforms and citations", "读取报告指标、平台与引用页"],
    "output_schema": {
      "additionalProperties": false,
      "properties": {
        "as_of": {
          "type": "string"
        },
        "citations": {
          "items": {
            "type": "object"
          },
          "type": "array"
        },
        "current": {
          "type": "object"
        },
        "days": {
          "type": "integer"
        },
        "platforms": {
          "items": {
            "type": "object"
          },
          "type": "array"
        },
        "previous": {
          "type": "object"
        },
        "previous_citations": {
          "items": {
            "type": "object"
          },
          "type": "array"
        },
        "previous_samples": {
          "type": "integer"
        },
        "samples": {
          "type": "integer"
        },
        "units": {
          "type": "string"
        }
      },
      "required": [
        "samples",
        "previous_samples",
        "current",
        "previous",
        "platforms",
        "citations",
        "previous_citations",
        "days",
        "as_of",
        "units"
      ],
      "type": "object"
    },
    "permission": "read",
    "requirements": {
      "locale": "not_applicable",
      "period": "not_applicable",
      "prerequisites": [
        {
          "code": "permission",
          "label": ["Current brand read access is required.", "需要当前品牌的读取权限。"],
          "remedies": ["human"]
        }
      ],
      "scope": "current_brand",
      "sources": "scoped_database"
    },
    "retry": {
      "backoff_seconds": 0,
      "max_attempts": 1
    },
    "stall_seconds": 600,
    "storage": "samples, sample_mentions, sample_citations",
    "version": 1
  },
  {
    "cancel": "synchronous",
    "completion": "sync",
    "effects": "read",
    "errors": ["unauthorized", "not_found", "forbidden", "gated", "conflict", "bad_request"],
    "fee": "free",
    "id": "citations.read",
    "input_schema": {
      "additionalProperties": false,
      "properties": {
        "days": {
          "maximum": 365,
          "minimum": 1,
          "type": "integer"
        },
        "engine": {
          "type": "string"
        },
        "intent": {
          "type": "string"
        },
        "locale": {
          "type": "string"
        },
        "offset": {
          "maximum": 1000000,
          "minimum": 0,
          "type": "integer"
        },
        "topics": {
          "items": {
            "type": "string"
          },
          "maxItems": 100,
          "type": "array"
        }
      },
      "required": ["locale", "days"],
      "type": "object"
    },
    "label": ["Read most cited pages", "读取高频引用页"],
    "output_schema": {
      "additionalProperties": false,
      "properties": {
        "next_offset": {
          "type": "integer"
        },
        "pages": {
          "items": {
            "type": "object"
          },
          "type": "array"
        }
      },
      "required": ["pages"],
      "type": "object"
    },
    "permission": "read",
    "requirements": {
      "locale": "not_applicable",
      "period": "not_applicable",
      "prerequisites": [
        {
          "code": "permission",
          "label": ["Current brand read access is required.", "需要当前品牌的读取权限。"],
          "remedies": ["human"]
        }
      ],
      "scope": "current_brand",
      "sources": "scoped_database"
    },
    "retry": {
      "backoff_seconds": 0,
      "max_attempts": 1
    },
    "stall_seconds": 600,
    "storage": "sample_citations",
    "version": 1
  },
  {
    "cancel": "synchronous",
    "completion": "sync",
    "effects": "read",
    "errors": ["unauthorized", "not_found", "forbidden", "gated", "conflict", "bad_request"],
    "fee": "free",
    "id": "citations.research",
    "input_schema": {
      "additionalProperties": false,
      "properties": {
        "citations": {
          "type": "object"
        }
      },
      "required": ["citations"],
      "type": "object"
    },
    "label": ["Read three cited competitor pages", "读取三篇被引用的竞品页面"],
    "output_schema": {
      "additionalProperties": false,
      "properties": {
        "pages": {
          "items": {
            "type": "object"
          },
          "type": "array"
        },
        "unavailable": {
          "items": {
            "type": "string"
          },
          "type": "array"
        }
      },
      "required": ["pages", "unavailable"],
      "type": "object"
    },
    "permission": "read",
    "requirements": {
      "locale": "not_applicable",
      "period": "not_applicable",
      "prerequisites": [
        {
          "code": "permission",
          "label": ["Current brand read access is required.", "需要当前品牌的读取权限。"],
          "remedies": ["human"]
        }
      ],
      "scope": "current_brand",
      "sources": "scoped_database"
    },
    "retry": {
      "backoff_seconds": 0,
      "max_attempts": 1
    },
    "stall_seconds": 600,
    "storage": "operations.output",
    "version": 1
  },
  {
    "cancel": "synchronous",
    "completion": "sync",
    "effects": "read",
    "errors": ["unauthorized", "not_found", "forbidden", "gated", "conflict", "bad_request"],
    "fee": "free",
    "id": "web.sitemap",
    "input_schema": {
      "additionalProperties": false,
      "properties": {
        "url": {
          "maxLength": 2000,
          "type": "string"
        }
      },
      "required": ["url"],
      "type": "object"
    },
    "label": ["Read sitemap links", "读取站点地图链接"],
    "output_schema": {
      "additionalProperties": false,
      "properties": {
        "links": {
          "items": {
            "type": "string"
          },
          "type": "array"
        },
        "truncated": {
          "type": "boolean"
        },
        "url": {
          "type": "string"
        }
      },
      "required": ["url", "links", "truncated"],
      "type": "object"
    },
    "permission": "read",
    "requirements": {
      "locale": "not_applicable",
      "period": "not_applicable",
      "prerequisites": [
        {
          "code": "permission",
          "label": ["Current brand read access is required.", "需要当前品牌的读取权限。"],
          "remedies": ["human"]
        }
      ],
      "scope": "current_brand",
      "sources": "scoped_database"
    },
    "retry": {
      "backoff_seconds": 0,
      "max_attempts": 1
    },
    "stall_seconds": 600,
    "storage": "operations.output",
    "version": 1
  },
  {
    "cancel": "synchronous",
    "completion": "sync",
    "effects": "read",
    "errors": ["unauthorized", "not_found", "forbidden", "gated", "conflict", "bad_request"],
    "fee": "free",
    "id": "sentiment.aggregate",
    "input_schema": {
      "additionalProperties": false,
      "properties": {
        "analysis": {
          "type": "object"
        }
      },
      "required": ["analysis"],
      "type": "object"
    },
    "label": ["Aggregate measured theme evidence", "汇总已测情绪主题证据"],
    "output_schema": {
      "additionalProperties": false,
      "properties": {
        "mentions": {
          "type": "integer"
        },
        "moods": {
          "items": {
            "type": "object"
          },
          "type": "array"
        },
        "read": {
          "type": "integer"
        },
        "themes": {
          "items": {
            "type": "object"
          },
          "type": "array"
        }
      },
      "required": ["read", "mentions", "moods", "themes"],
      "type": "object"
    },
    "permission": "read",
    "requirements": {
      "locale": "not_applicable",
      "period": "not_applicable",
      "prerequisites": [
        {
          "code": "permission",
          "label": ["Current brand read access is required.", "需要当前品牌的读取权限。"],
          "remedies": ["human"]
        }
      ],
      "scope": "current_brand",
      "sources": "scoped_database"
    },
    "retry": {
      "backoff_seconds": 0,
      "max_attempts": 1
    },
    "stall_seconds": 600,
    "storage": "operations.output",
    "version": 1
  },
  {
    "cancel": "synchronous",
    "completion": "sync",
    "effects": "read",
    "errors": ["unauthorized", "not_found", "forbidden", "gated", "conflict", "bad_request"],
    "fee": "free",
    "id": "url.validate",
    "input_schema": {
      "additionalProperties": false,
      "properties": {
        "original": {
          "maxLength": 2000,
          "type": "string"
        },
        "proposal": {
          "type": "object"
        }
      },
      "required": ["original", "proposal"],
      "type": "object"
    },
    "label": ["Validate proposed URL", "校验建议网址"],
    "output_schema": {
      "additionalProperties": false,
      "properties": {
        "markdown": {
          "type": "string"
        },
        "title": {
          "type": "string"
        },
        "url": {
          "type": "string"
        }
      },
      "required": ["title", "markdown", "url"],
      "type": "object"
    },
    "permission": "read",
    "requirements": {
      "locale": "not_applicable",
      "period": "not_applicable",
      "prerequisites": [
        {
          "code": "permission",
          "label": ["Current brand read access is required.", "需要当前品牌的读取权限。"],
          "remedies": ["human"]
        }
      ],
      "scope": "current_brand",
      "sources": "scoped_database"
    },
    "retry": {
      "backoff_seconds": 0,
      "max_attempts": 1
    },
    "stall_seconds": 600,
    "storage": "operations.output",
    "version": 1
  },
  {
    "cancel": "synchronous",
    "completion": "sync",
    "effects": "read",
    "errors": ["unauthorized", "not_found", "forbidden", "gated", "conflict", "bad_request"],
    "fee": "free",
    "id": "schema.format",
    "input_schema": {
      "additionalProperties": false,
      "properties": {
        "schema": {
          "type": "object"
        },
        "wrap": {
          "type": "boolean"
        }
      },
      "required": ["schema", "wrap"],
      "type": "object"
    },
    "label": ["Validate and format JSON-LD", "校验并格式化 JSON-LD"],
    "output_schema": {
      "additionalProperties": false,
      "properties": {
        "markdown": {
          "type": "string"
        }
      },
      "required": ["markdown"],
      "type": "object"
    },
    "permission": "read",
    "requirements": {
      "locale": "not_applicable",
      "period": "not_applicable",
      "prerequisites": [
        {
          "code": "permission",
          "label": ["Current brand read access is required.", "需要当前品牌的读取权限。"],
          "remedies": ["human"]
        }
      ],
      "scope": "current_brand",
      "sources": "scoped_database"
    },
    "retry": {
      "backoff_seconds": 0,
      "max_attempts": 1
    },
    "stall_seconds": 600,
    "storage": "operations.output",
    "version": 1
  },
  {
    "cancel": "synchronous",
    "completion": "sync",
    "effects": "read",
    "errors": ["unauthorized", "not_found", "forbidden", "gated", "conflict", "bad_request"],
    "fee": "free",
    "id": "content.source",
    "input_schema": {
      "additionalProperties": false,
      "properties": {
        "text": {
          "maxLength": 16000,
          "type": "string"
        },
        "url": {
          "maxLength": 2000,
          "type": "string"
        }
      },
      "required": ["url", "text"],
      "type": "object"
    },
    "label": ["Read article source", "读取文章素材"],
    "output_schema": {
      "additionalProperties": false,
      "properties": {
        "headings": {
          "items": {
            "type": "string"
          },
          "type": "array"
        },
        "text": {
          "type": "string"
        },
        "truncated": {
          "type": "boolean"
        },
        "url": {
          "type": "string"
        }
      },
      "required": ["url", "text", "truncated", "headings"],
      "type": "object"
    },
    "permission": "read",
    "requirements": {
      "locale": "not_applicable",
      "period": "not_applicable",
      "prerequisites": [
        {
          "code": "permission",
          "label": ["Current brand read access is required.", "需要当前品牌的读取权限。"],
          "remedies": ["human"]
        }
      ],
      "scope": "current_brand",
      "sources": "scoped_database"
    },
    "retry": {
      "backoff_seconds": 0,
      "max_attempts": 1
    },
    "stall_seconds": 600,
    "storage": "operations.output",
    "version": 1
  },
  {
    "cancel": "synchronous",
    "completion": "sync",
    "effects": "read",
    "errors": ["unauthorized", "not_found", "forbidden", "gated", "conflict", "bad_request"],
    "fee": "free",
    "id": "prompt.compose",
    "input_schema": {
      "additionalProperties": false,
      "properties": {
        "brand": {
          "type": "object"
        },
        "evidence": {
          "type": "object"
        },
        "instruction": {
          "maxLength": 16000,
          "type": "string"
        },
        "parameters": {
          "type": "object"
        },
        "previous": {
          "type": "object"
        },
        "research": {
          "type": "object"
        },
        "source": {
          "type": "object"
        }
      },
      "required": ["instruction", "parameters", "source", "brand", "evidence", "previous"],
      "type": "object"
    },
    "label": ["Assemble evidence and instructions", "组装证据与任务指令"],
    "output_schema": {
      "additionalProperties": false,
      "properties": {
        "text": {
          "type": "string"
        }
      },
      "required": ["text"],
      "type": "object"
    },
    "permission": "read",
    "requirements": {
      "locale": "not_applicable",
      "period": "not_applicable",
      "prerequisites": [
        {
          "code": "permission",
          "label": ["Current brand read access is required.", "需要当前品牌的读取权限。"],
          "remedies": ["human"]
        }
      ],
      "scope": "current_brand",
      "sources": "scoped_database"
    },
    "retry": {
      "backoff_seconds": 0,
      "max_attempts": 1
    },
    "stall_seconds": 600,
    "storage": "operations.output",
    "version": 1
  },
  {
    "cancel": "synchronous",
    "completion": "sync",
    "effects": "read",
    "errors": ["unauthorized", "not_found", "forbidden", "gated", "conflict", "bad_request"],
    "fee": "free",
    "id": "web.read",
    "input_schema": {
      "additionalProperties": false,
      "properties": {
        "url": {
          "maxLength": 2000,
          "type": "string"
        }
      },
      "required": ["url"],
      "type": "object"
    },
    "label": ["Read web page", "读取网页"],
    "output_schema": {
      "additionalProperties": false,
      "properties": {
        "page": {
          "type": "object"
        },
        "url": {
          "type": "string"
        }
      },
      "required": ["url", "page"],
      "type": "object"
    },
    "permission": "read",
    "requirements": {
      "locale": "not_applicable",
      "period": "not_applicable",
      "prerequisites": [
        {
          "code": "permission",
          "label": ["Current brand read access is required.", "需要当前品牌的读取权限。"],
          "remedies": ["human"]
        }
      ],
      "scope": "current_brand",
      "sources": "scoped_database"
    },
    "retry": {
      "backoff_seconds": 0,
      "max_attempts": 1
    },
    "stall_seconds": 600,
    "storage": "operations.output",
    "version": 1
  },
  {
    "cancel": "synchronous",
    "completion": "sync",
    "effects": "read",
    "errors": ["unauthorized", "not_found", "forbidden", "gated", "conflict", "bad_request"],
    "fee": "free",
    "id": "web.links",
    "input_schema": {
      "additionalProperties": false,
      "properties": {
        "url": {
          "maxLength": 2000,
          "type": "string"
        }
      },
      "required": ["url"],
      "type": "object"
    },
    "label": ["Extract page links", "提取网页链接"],
    "output_schema": {
      "additionalProperties": false,
      "properties": {
        "links": {
          "items": {
            "type": "string"
          },
          "type": "array"
        },
        "url": {
          "type": "string"
        }
      },
      "required": ["url", "links"],
      "type": "object"
    },
    "permission": "read",
    "requirements": {
      "locale": "not_applicable",
      "period": "not_applicable",
      "prerequisites": [
        {
          "code": "permission",
          "label": ["Current brand read access is required.", "需要当前品牌的读取权限。"],
          "remedies": ["human"]
        }
      ],
      "scope": "current_brand",
      "sources": "scoped_database"
    },
    "retry": {
      "backoff_seconds": 0,
      "max_attempts": 1
    },
    "stall_seconds": 600,
    "storage": "operations.output",
    "version": 1
  },
  {
    "cancel": "synchronous",
    "completion": "sync",
    "effects": "read",
    "errors": ["unauthorized", "not_found", "forbidden", "gated", "conflict", "bad_request"],
    "fee": "free",
    "id": "text.join",
    "input_schema": {
      "additionalProperties": false,
      "properties": {
        "separator": {
          "maxLength": 100,
          "type": "string"
        },
        "texts": {
          "items": {
            "maxLength": 10000,
            "type": "string"
          },
          "maxItems": 100,
          "type": "array"
        }
      },
      "required": ["texts", "separator"],
      "type": "object"
    },
    "label": ["Combine text", "合并文本"],
    "output_schema": {
      "additionalProperties": false,
      "properties": {
        "text": {
          "type": "string"
        }
      },
      "required": ["text"],
      "type": "object"
    },
    "permission": "read",
    "requirements": {
      "locale": "not_applicable",
      "period": "not_applicable",
      "prerequisites": [
        {
          "code": "permission",
          "label": ["Current brand read access is required.", "需要当前品牌的读取权限。"],
          "remedies": ["human"]
        }
      ],
      "scope": "current_brand",
      "sources": "scoped_database"
    },
    "retry": {
      "backoff_seconds": 0,
      "max_attempts": 1
    },
    "stall_seconds": 600,
    "storage": "operations.output",
    "version": 1
  },
  {
    "cancel": "synchronous",
    "completion": "sync",
    "effects": "read",
    "errors": ["unauthorized", "not_found", "forbidden", "gated", "conflict", "bad_request"],
    "fee": "free",
    "id": "list.unique",
    "input_schema": {
      "additionalProperties": false,
      "properties": {
        "items": {
          "items": {
            "maxLength": 10000,
            "type": "string"
          },
          "maxItems": 1000,
          "type": "array"
        }
      },
      "required": ["items"],
      "type": "object"
    },
    "label": ["Remove duplicate items", "列表去重"],
    "output_schema": {
      "additionalProperties": false,
      "properties": {
        "count": {
          "type": "integer"
        },
        "items": {
          "items": {
            "type": "string"
          },
          "type": "array"
        }
      },
      "required": ["items", "count"],
      "type": "object"
    },
    "permission": "read",
    "requirements": {
      "locale": "not_applicable",
      "period": "not_applicable",
      "prerequisites": [
        {
          "code": "permission",
          "label": ["Current brand read access is required.", "需要当前品牌的读取权限。"],
          "remedies": ["human"]
        }
      ],
      "scope": "current_brand",
      "sources": "scoped_database"
    },
    "retry": {
      "backoff_seconds": 0,
      "max_attempts": 1
    },
    "stall_seconds": 600,
    "storage": "operations.output",
    "version": 1
  },
  {
    "cancel": "synchronous",
    "completion": "sync",
    "effects": "read",
    "errors": ["unauthorized", "not_found", "forbidden", "gated", "conflict", "bad_request"],
    "fee": "free",
    "id": "list.slice",
    "input_schema": {
      "additionalProperties": false,
      "properties": {
        "items": {
          "items": {
            "maxLength": 10000,
            "type": "string"
          },
          "maxItems": 1000,
          "type": "array"
        },
        "limit": {
          "maximum": 1000,
          "minimum": 1,
          "type": "integer"
        },
        "offset": {
          "maximum": 1000,
          "minimum": 0,
          "type": "integer"
        }
      },
      "required": ["items", "offset", "limit"],
      "type": "object"
    },
    "label": ["Select list range", "截取列表"],
    "output_schema": {
      "additionalProperties": false,
      "properties": {
        "count": {
          "type": "integer"
        },
        "items": {
          "items": {
            "type": "string"
          },
          "type": "array"
        }
      },
      "required": ["items", "count"],
      "type": "object"
    },
    "permission": "read",
    "requirements": {
      "locale": "not_applicable",
      "period": "not_applicable",
      "prerequisites": [
        {
          "code": "permission",
          "label": ["Current brand read access is required.", "需要当前品牌的读取权限。"],
          "remedies": ["human"]
        }
      ],
      "scope": "current_brand",
      "sources": "scoped_database"
    },
    "retry": {
      "backoff_seconds": 0,
      "max_attempts": 1
    },
    "stall_seconds": 600,
    "storage": "operations.output",
    "version": 1
  },
  {
    "cancel": "synchronous",
    "completion": "sync",
    "effects": "read",
    "errors": ["unauthorized", "not_found", "forbidden", "gated", "conflict", "bad_request"],
    "fee": "free",
    "id": "samples.latest",
    "input_schema": {
      "additionalProperties": false,
      "properties": {
        "locale": {
          "type": "string"
        }
      },
      "required": ["locale"],
      "type": "object"
    },
    "label": ["Read latest completed sample batches", "读取最近完成的采样批次"],
    "output_schema": {
      "additionalProperties": false,
      "properties": {
        "batches": {
          "items": {
            "properties": {
              "batch_id": {
                "type": "string"
              },
              "engine": {
                "type": "string"
              },
              "model": {
                "type": "string"
              }
            },
            "required": ["batch_id", "engine", "model"],
            "type": "object"
          },
          "type": "array"
        }
      },
      "required": ["batches"],
      "type": "object"
    },
    "permission": "read",
    "requirements": {
      "locale": "input_locale",
      "period": "explicit_or_latest_batch",
      "prerequisites": [
        {
          "code": "permission",
          "label": ["Current brand read access is required.", "需要当前品牌的读取权限。"],
          "remedies": ["human"]
        }
      ],
      "scope": "current_brand",
      "sources": "scoped_sample_batches"
    },
    "retry": {
      "backoff_seconds": 0,
      "max_attempts": 1
    },
    "stall_seconds": 600,
    "storage": "sample_batches",
    "version": 1
  },
  {
    "cancel": "synchronous",
    "completion": "sync",
    "effects": "read",
    "errors": ["unauthorized", "not_found", "forbidden", "gated", "conflict", "bad_request"],
    "fee": "free",
    "id": "content.select",
    "input_schema": {
      "additionalProperties": false,
      "properties": {
        "auto_publish": {
          "type": "boolean"
        },
        "before_batches": {
          "items": {
            "properties": {
              "batch_id": {
                "type": "string"
              }
            },
            "required": ["batch_id"],
            "type": "object"
          },
          "type": "array"
        },
        "block_dirty_facts": {
          "type": "boolean"
        },
        "daily": {
          "type": "boolean"
        },
        "locale": {
          "type": "string"
        },
        "max_pages": {
          "maximum": 20,
          "minimum": 0,
          "type": "integer"
        },
        "observation_days": {
          "maximum": 90,
          "minimum": 14,
          "type": "integer"
        },
        "quality": {
          "enum": ["standard", "deep"],
          "type": "string"
        }
      },
      "required": ["locale", "max_pages"],
      "type": "object"
    },
    "label": ["Select open content directions", "选择待处理内容方向"],
    "output_schema": {
      "additionalProperties": false,
      "properties": {
        "blocked": {
          "items": {
            "properties": {
              "gap_id": {
                "type": "string"
              },
              "reason": {
                "type": "string"
              }
            },
            "required": ["gap_id", "reason"],
            "type": "object"
          },
          "type": "array"
        },
        "pages": {
          "items": {
            "additionalProperties": false,
            "properties": {
              "auto_publish": {
                "type": "boolean"
              },
              "before_batches": {
                "items": {
                  "properties": {
                    "batch_id": {
                      "type": "string"
                    }
                  },
                  "required": ["batch_id"],
                  "type": "object"
                },
                "type": "array"
              },
              "block_dirty_facts": {
                "type": "boolean"
              },
              "gap_id": {
                "type": "string"
              },
              "locale": {
                "type": "string"
              },
              "observation_seconds": {
                "type": "integer"
              },
              "quality": {
                "type": "string"
              },
              "recipe": {
                "type": "string"
              }
            },
            "required": [
              "recipe",
              "locale",
              "quality",
              "auto_publish",
              "block_dirty_facts",
              "observation_seconds",
              "before_batches",
              "gap_id"
            ],
            "type": "object"
          },
          "type": "array"
        }
      },
      "required": ["pages", "blocked"],
      "type": "object"
    },
    "permission": "read",
    "requirements": {
      "locale": "input_locale",
      "period": "not_applicable",
      "prerequisites": [
        {
          "code": "permission",
          "label": ["Current brand read access is required.", "需要当前品牌的读取权限。"],
          "remedies": ["human"]
        }
      ],
      "scope": "current_brand",
      "sources": "stored_content_evidence"
    },
    "retry": {
      "backoff_seconds": 0,
      "max_attempts": 1
    },
    "stall_seconds": 600,
    "storage": "gaps",
    "version": 1
  },
  {
    "cancel": "synchronous",
    "completion": "sync",
    "effects": "read",
    "errors": ["unauthorized", "not_found", "forbidden", "gated", "conflict", "bad_request"],
    "fee": "free",
    "id": "content.scope",
    "input_schema": {
      "additionalProperties": false,
      "properties": {
        "auto_publish": {
          "type": "boolean"
        },
        "before_batches": {
          "items": {
            "properties": {
              "batch_id": {
                "type": "string"
              }
            },
            "required": ["batch_id"],
            "type": "object"
          },
          "type": "array"
        },
        "block_dirty_facts": {
          "type": "boolean"
        },
        "locale": {
          "type": "string"
        },
        "max_pages": {
          "maximum": 2,
          "minimum": 1,
          "type": "integer"
        },
        "observation_days": {
          "maximum": 90,
          "minimum": 14,
          "type": "integer"
        },
        "quality": {
          "enum": ["standard", "deep"],
          "type": "string"
        },
        "recipes": {
          "items": {
            "enum": ["entity.enrich", "faq.clarify"],
            "type": "string"
          },
          "maxItems": 2,
          "minItems": 1,
          "type": "array"
        }
      },
      "required": [
        "locale",
        "quality",
        "max_pages",
        "observation_days",
        "auto_publish",
        "block_dirty_facts",
        "recipes",
        "before_batches"
      ],
      "type": "object"
    },
    "label": ["Limit selected content to the run scope", "按运行范围安排所选内容"],
    "output_schema": {
      "additionalProperties": false,
      "properties": {
        "omitted": {
          "items": {
            "type": "string"
          },
          "type": "array"
        },
        "pages": {
          "items": {
            "additionalProperties": false,
            "properties": {
              "auto_publish": {
                "type": "boolean"
              },
              "before_batches": {
                "items": {
                  "properties": {
                    "batch_id": {
                      "type": "string"
                    }
                  },
                  "required": ["batch_id"],
                  "type": "object"
                },
                "type": "array"
              },
              "block_dirty_facts": {
                "type": "boolean"
              },
              "locale": {
                "type": "string"
              },
              "observation_seconds": {
                "type": "integer"
              },
              "quality": {
                "type": "string"
              },
              "recipe": {
                "type": "string"
              }
            },
            "required": [
              "recipe",
              "locale",
              "quality",
              "auto_publish",
              "block_dirty_facts",
              "observation_seconds",
              "before_batches"
            ],
            "type": "object"
          },
          "type": "array"
        }
      },
      "required": ["pages", "omitted"],
      "type": "object"
    },
    "permission": "read",
    "requirements": {
      "locale": "input_locale",
      "period": "not_applicable",
      "prerequisites": [
        {
          "code": "permission",
          "label": ["Current brand read access is required.", "需要当前品牌的读取权限。"],
          "remedies": ["human"]
        }
      ],
      "scope": "current_brand",
      "sources": "stored_content_evidence"
    },
    "retry": {
      "backoff_seconds": 0,
      "max_attempts": 1
    },
    "stall_seconds": 600,
    "storage": "operations.output",
    "version": 1
  },
  {
    "cancel": "synchronous",
    "completion": "sync",
    "effects": "read",
    "errors": ["unauthorized", "not_found", "forbidden", "gated", "conflict", "bad_request"],
    "fee": "free",
    "id": "workflow.readiness",
    "input_schema": {
      "additionalProperties": false,
      "properties": {
        "batches": {
          "items": {
            "properties": {
              "batch_id": {
                "type": "string"
              }
            },
            "required": ["batch_id"],
            "type": "object"
          },
          "type": "array"
        },
        "locale": {
          "type": "string"
        }
      },
      "required": ["locale", "batches"],
      "type": "object"
    },
    "label": ["Check workflow prerequisites", "检查流程前置条件"],
    "output_schema": {
      "additionalProperties": false,
      "properties": {
        "answers": {
          "type": "integer"
        },
        "batches_complete": {
          "type": "boolean"
        },
        "can_sample": {
          "type": "boolean"
        },
        "checkable_answers": {
          "type": "integer"
        },
        "credits": {
          "type": "integer"
        },
        "factcheck_clean": {
          "type": "boolean"
        },
        "facts_ready": {
          "type": "boolean"
        },
        "open_claims": {
          "type": "integer"
        },
        "ownership_recorded": {
          "type": "boolean"
        },
        "pages_remaining": {
          "type": "integer"
        },
        "questions": {
          "type": "integer"
        },
        "questions_ready": {
          "type": "boolean"
        },
        "sourced_facts": {
          "type": "integer"
        },
        "spend_gate": {
          "type": "string"
        },
        "unchecked_answers": {
          "type": "integer"
        }
      },
      "required": [
        "ownership_recorded",
        "sourced_facts",
        "facts_ready",
        "questions",
        "questions_ready",
        "can_sample",
        "spend_gate",
        "credits",
        "batches_complete",
        "answers",
        "checkable_answers",
        "unchecked_answers",
        "open_claims",
        "factcheck_clean",
        "pages_remaining"
      ],
      "type": "object"
    },
    "permission": "read",
    "requirements": {
      "locale": "input_locale",
      "period": "explicit_or_latest_batch",
      "prerequisites": [
        {
          "code": "permission",
          "label": ["Current brand read access is required.", "需要当前品牌的读取权限。"],
          "remedies": ["human"]
        }
      ],
      "scope": "current_brand",
      "sources": "scoped_sample_batches"
    },
    "retry": {
      "backoff_seconds": 0,
      "max_attempts": 1
    },
    "stall_seconds": 600,
    "storage": "entities, questions, sample_batches, sample_factchecks, claims, ledger, pages",
    "version": 1
  },
  {
    "cancel": "synchronous",
    "completion": "sync",
    "effects": "write",
    "errors": ["unauthorized", "not_found", "forbidden", "gated", "conflict", "bad_request"],
    "fee": "free",
    "id": "brand.supplement",
    "input_schema": {
      "additionalProperties": false,
      "properties": {
        "description": {
          "type": "string"
        },
        "facts": {
          "type": "object"
        },
        "tagline_en": {
          "type": "string"
        },
        "tagline_zh": {
          "type": "string"
        }
      },
      "required": [],
      "type": "object"
    },
    "label": ["Supplement missing brand information", "补充缺失的品牌资料"],
    "output_schema": {
      "additionalProperties": false,
      "properties": {
        "entity_id": {
          "type": "string"
        },
        "facts_added": {
          "type": "integer"
        },
        "verified": {
          "type": "boolean"
        }
      },
      "required": ["entity_id", "facts_added", "verified"],
      "type": "object"
    },
    "permission": "brand_edit",
    "requirements": {
      "locale": "not_applicable",
      "period": "not_applicable",
      "prerequisites": [
        {
          "code": "permission",
          "label": ["Current brand editor access is required.", "需要当前品牌的编辑权限。"],
          "remedies": ["human"]
        },
        {
          "code": "operable",
          "label": ["The account must permit business changes.", "账户需处于可操作状态。"],
          "remedies": ["human"]
        },
        {
          "code": "supplied_evidence",
          "label": [
            "Use supplied facts and source URLs; do not mark model output as verified evidence.",
            "使用已提供事实与来源链接，不得把模型输出标为已验证证据。"
          ],
          "remedies": ["human"]
        }
      ],
      "scope": "current_brand",
      "sources": "user_supplied_evidence"
    },
    "retry": {
      "backoff_seconds": 0,
      "max_attempts": 1
    },
    "stall_seconds": 600,
    "storage": "entities",
    "version": 1
  },
  {
    "cancel": "synchronous",
    "completion": "sync",
    "effects": "write",
    "errors": ["unauthorized", "not_found", "forbidden", "gated", "conflict", "bad_request"],
    "fee": "free",
    "id": "facts.source",
    "input_schema": {
      "additionalProperties": false,
      "properties": {
        "expected_fact": {
          "type": "object"
        },
        "key": {
          "type": "string"
        },
        "source_url": {
          "type": "string"
        }
      },
      "required": ["key", "expected_fact", "source_url"],
      "type": "object"
    },
    "label": ["Record a fact source", "记录事实来源"],
    "output_schema": {
      "additionalProperties": false,
      "properties": {
        "entity_id": {
          "type": "string"
        },
        "key": {
          "type": "string"
        },
        "source_url": {
          "type": "string"
        },
        "verified": {
          "type": "boolean"
        }
      },
      "required": ["entity_id", "key", "source_url", "verified"],
      "type": "object"
    },
    "permission": "brand_edit",
    "requirements": {
      "locale": "not_applicable",
      "period": "not_applicable",
      "prerequisites": [
        {
          "code": "permission",
          "label": ["Current brand editor access is required.", "需要当前品牌的编辑权限。"],
          "remedies": ["human"]
        },
        {
          "code": "operable",
          "label": ["The account must permit business changes.", "账户需处于可操作状态。"],
          "remedies": ["human"]
        },
        {
          "code": "supplied_evidence",
          "label": [
            "Use supplied facts and source URLs; do not mark model output as verified evidence.",
            "使用已提供事实与来源链接，不得把模型输出标为已验证证据。"
          ],
          "remedies": ["human"]
        }
      ],
      "scope": "current_brand",
      "sources": "user_supplied_evidence"
    },
    "retry": {
      "backoff_seconds": 0,
      "max_attempts": 1
    },
    "stall_seconds": 600,
    "storage": "entities.datapoints",
    "version": 1
  },
  {
    "cancel": "synchronous",
    "completion": "sync",
    "effects": "write",
    "errors": ["unauthorized", "not_found", "forbidden", "gated", "conflict", "bad_request"],
    "fee": "free",
    "id": "platform.prepare",
    "input_schema": {
      "additionalProperties": false,
      "properties": {
        "payload": {
          "type": "object"
        }
      },
      "required": ["payload"],
      "type": "object"
    },
    "label": ["Prepare platform publishing task", "准备平台发布待办"],
    "output_schema": {
      "additionalProperties": false,
      "properties": {
        "task": {
          "type": "object"
        }
      },
      "required": ["task"],
      "type": "object"
    },
    "permission": "brand_edit",
    "requirements": {
      "locale": "not_applicable",
      "period": "not_applicable",
      "prerequisites": [
        {
          "code": "permission",
          "label": ["Current brand editor access is required.", "需要当前品牌的编辑权限。"],
          "remedies": ["human"]
        },
        {
          "code": "operable",
          "label": ["The account must permit business changes.", "账户需处于可操作状态。"],
          "remedies": ["human"]
        },
        {
          "code": "page_revision",
          "label": [
            "Use this brand's stored page and its current working revision.",
            "使用当前品牌的已保存页面及其当前工作修订。"
          ],
          "remedies": ["draft.generate", "draft.read", "human"]
        }
      ],
      "scope": "current_brand",
      "sources": "stored_page_revision"
    },
    "retry": {
      "backoff_seconds": 0,
      "max_attempts": 1
    },
    "stall_seconds": 600,
    "storage": "platform_publish_tasks",
    "version": 1
  },
  {
    "cancel": "synchronous",
    "completion": "sync",
    "effects": "write",
    "errors": ["unauthorized", "not_found", "forbidden", "gated", "conflict", "bad_request"],
    "fee": "free",
    "id": "platform.publish",
    "input_schema": {
      "additionalProperties": false,
      "properties": {
        "at": {
          "type": "string"
        },
        "credential_id": {
          "type": "string"
        },
        "task_id": {
          "type": "string"
        }
      },
      "required": ["task_id", "credential_id"],
      "type": "object"
    },
    "label": ["Send a prepared platform task", "提交已准备的平台待办"],
    "output_schema": {
      "additionalProperties": false,
      "properties": {
        "task": {
          "type": "object"
        }
      },
      "required": ["task"],
      "type": "object"
    },
    "permission": "brand_edit",
    "requirements": {
      "locale": "not_applicable",
      "period": "not_applicable",
      "prerequisites": [
        {
          "code": "permission",
          "label": ["Current brand editor access is required.", "需要当前品牌的编辑权限。"],
          "remedies": ["human"]
        },
        {
          "code": "operable",
          "label": ["The account must permit business changes.", "账户需处于可操作状态。"],
          "remedies": ["human"]
        },
        {
          "code": "page_revision",
          "label": [
            "Use this brand's stored page and its current working revision.",
            "使用当前品牌的已保存页面及其当前工作修订。"
          ],
          "remedies": ["draft.generate", "draft.read", "human"]
        }
      ],
      "scope": "current_brand",
      "sources": "stored_page_revision"
    },
    "retry": {
      "backoff_seconds": 0,
      "max_attempts": 1
    },
    "stall_seconds": 600,
    "storage": "platform_publish_tasks",
    "version": 1
  },
  {
    "cancel": "synchronous",
    "completion": "sync",
    "effects": "read",
    "errors": ["unauthorized", "not_found", "forbidden", "gated", "conflict", "bad_request"],
    "fee": "free",
    "id": "delivery.read",
    "input_schema": {
      "additionalProperties": false,
      "properties": {},
      "required": [],
      "type": "object"
    },
    "label": ["Read platform publishing tasks and receipts", "读取平台发布任务与回执"],
    "output_schema": {
      "additionalProperties": false,
      "properties": {
        "platform": {
          "type": "object"
        }
      },
      "required": ["platform"],
      "type": "object"
    },
    "permission": "read",
    "requirements": {
      "locale": "not_applicable",
      "period": "not_applicable",
      "prerequisites": [
        {
          "code": "permission",
          "label": ["Current brand read access is required.", "需要当前品牌的读取权限。"],
          "remedies": ["human"]
        }
      ],
      "scope": "current_brand",
      "sources": "scoped_database"
    },
    "retry": {
      "backoff_seconds": 0,
      "max_attempts": 1
    },
    "stall_seconds": 600,
    "storage": "platform_publish_tasks",
    "version": 1
  },
  {
    "cancel": "synchronous",
    "completion": "sync",
    "effects": "read",
    "errors": ["unauthorized", "not_found", "forbidden", "gated", "conflict", "bad_request"],
    "fee": "free",
    "id": "delivery.platforms",
    "input_schema": {
      "additionalProperties": false,
      "properties": {},
      "required": [],
      "type": "object"
    },
    "label": ["Read platforms this brand can publish to", "读取本品牌可发布的平台"],
    "output_schema": {
      "additionalProperties": false,
      "properties": {
        "platforms": {
          "items": {
            "type": "object"
          },
          "type": "array"
        }
      },
      "required": ["platforms"],
      "type": "object"
    },
    "permission": "read",
    "requirements": {
      "locale": "not_applicable",
      "period": "not_applicable",
      "prerequisites": [
        {
          "code": "permission",
          "label": ["Current brand read access is required.", "需要当前品牌的读取权限。"],
          "remedies": ["human"]
        },
        {
          "code": "connected_account",
          "label": [
            "A platform is connected when the brand holds an account for it, connected under Settings → Publishing. Only WordPress, YouTube, Bluesky, Mastodon, Lemmy and Reddit can be sent from Ondit; every other platform is delivered by hand or with the browser assistant. Adapting content for a platform needs no account: choose platforms by language and format, not by whether they are connected; the connection only decides whether Ondit or a person sends the approved version.",
            "平台已连接指品牌有它的账号，在“设置 → 发布”里连接。只有 WordPress、YouTube、Bluesky、Mastodon、Lemmy 和 Reddit 能从 Ondit 直接发送；其余平台靠手动或浏览器助手发布。为平台适配内容不需要账号：按语言和内容形式挑平台，不要只挑已连接的；是否连接只决定确认后的版本由 Ondit 发送还是由人发布。"
          ],
          "remedies": ["human"]
        }
      ],
      "scope": "current_brand",
      "sources": "platform_registry"
    },
    "retry": {
      "backoff_seconds": 0,
      "max_attempts": 1
    },
    "stall_seconds": 600,
    "storage": "distribution_platforms, credentials",
    "version": 1
  },
  {
    "cancel": "synchronous",
    "completion": "sync",
    "effects": "write",
    "errors": ["unauthorized", "not_found", "forbidden", "gated", "conflict", "bad_request"],
    "fee": "free",
    "id": "distribution.plan",
    "input_schema": {
      "additionalProperties": false,
      "properties": {
        "pages": {
          "items": {
            "additionalProperties": false,
            "properties": {
              "page_id": {
                "type": "string"
              },
              "platform_id": {
                "type": "string"
              },
              "format": {
                "type": "string"
              }
            },
            "required": ["page_id"],
            "type": "object"
          },
          "maxItems": 20,
          "minItems": 1,
          "type": "array"
        },
        "start": {
          "type": "string"
        }
      },
      "required": ["pages"],
      "type": "object"
    },
    "label": ["Put published pages on the calendar", "把已发布页面排入日历"],
    "output_schema": {
      "additionalProperties": false,
      "properties": {
        "omitted": {
          "items": {
            "type": "object"
          },
          "type": "array"
        },
        "planned": {
          "items": {
            "type": "object"
          },
          "type": "array"
        }
      },
      "required": ["planned", "omitted"],
      "type": "object"
    },
    "permission": "brand_edit",
    "requirements": {
      "locale": "not_applicable",
      "period": "not_applicable",
      "prerequisites": [
        {
          "code": "permission",
          "label": ["Current brand editor access is required.", "需要当前品牌的编辑权限。"],
          "remedies": ["human"]
        },
        {
          "code": "operable",
          "label": ["The account must permit business changes.", "账户需处于可操作状态。"],
          "remedies": ["human"]
        },
        {
          "code": "published_page",
          "label": [
            "Only a page already published on ondit can be planned; the calendar row points at its current revision.",
            "只有已在 ondit 发布的页面才能排期；日历行指向它当前的修订。"
          ],
          "remedies": ["page.publish", "human"]
        }
      ],
      "scope": "current_brand",
      "sources": "stored_page_revision"
    },
    "retry": {
      "backoff_seconds": 0,
      "max_attempts": 1
    },
    "stall_seconds": 600,
    "storage": "distribution_posts",
    "version": 1
  },
  {
    "cancel": "synchronous",
    "completion": "sync",
    "effects": "write",
    "errors": ["unauthorized", "not_found", "forbidden", "gated", "conflict", "bad_request"],
    "fee": "free",
    "id": "gaps.dismiss",
    "input_schema": {
      "additionalProperties": false,
      "properties": {
        "gap_ids": {
          "items": {
            "type": "string"
          },
          "maxItems": 50,
          "minItems": 1,
          "type": "array"
        },
        "restore": {
          "type": "boolean"
        }
      },
      "required": ["gap_ids"],
      "type": "object"
    },
    "label": ["Dismiss or restore gaps", "搁置或恢复缺口"],
    "output_schema": {
      "additionalProperties": false,
      "properties": {
        "status": {
          "type": "string"
        },
        "updated": {
          "type": "integer"
        }
      },
      "required": ["updated", "status"],
      "type": "object"
    },
    "permission": "brand_edit",
    "requirements": {
      "locale": "not_applicable",
      "period": "not_applicable",
      "prerequisites": [
        {
          "code": "permission",
          "label": ["Current brand editor access is required.", "需要当前品牌的编辑权限。"],
          "remedies": ["human"]
        },
        {
          "code": "operable",
          "label": ["The account must permit business changes.", "账户需处于可操作状态。"],
          "remedies": ["human"]
        },
        {
          "code": "question_gap",
          "label": [
            "Only a gap for a question can be dismissed; the brand's default gap holds the pages written for no question and stays.",
            "只有针对问题的缺口能搁置；品牌的默认缺口存放不针对问题写的页面，不能搁置。"
          ],
          "remedies": ["human"]
        }
      ],
      "scope": "current_brand",
      "sources": "stored_content_evidence"
    },
    "retry": {
      "backoff_seconds": 0,
      "max_attempts": 1
    },
    "stall_seconds": 600,
    "storage": "gaps",
    "version": 1
  },
  {
    "cancel": "drain_in_flight",
    "completion": "job",
    "effects": "write",
    "errors": ["unauthorized", "not_found", "forbidden", "gated", "conflict", "bad_request"],
    "fee": "metered",
    "id": "questions.generate",
    "input_schema": {
      "additionalProperties": false,
      "properties": {
        "count": {
          "type": "integer"
        },
        "locale": {
          "type": "string"
        },
        "topic": {
          "type": "string"
        }
      },
      "required": ["locale", "topic", "count"],
      "type": "object"
    },
    "label": ["Generate candidate questions", "生成候选问题"],
    "output_schema": {
      "additionalProperties": false,
      "properties": {
        "questions": {
          "items": {
            "additionalProperties": false,
            "properties": {
              "intent": {
                "type": "string"
              },
              "text": {
                "type": "string"
              }
            },
            "required": ["text", "intent"],
            "type": "object"
          },
          "type": "array"
        }
      },
      "required": ["questions"],
      "type": "object"
    },
    "permission": "brand_edit",
    "requirements": {
      "locale": "input_locale",
      "period": "not_applicable",
      "prerequisites": [
        {
          "code": "permission",
          "label": ["Current brand editor access is required.", "需要当前品牌的编辑权限。"],
          "remedies": ["human"]
        },
        {
          "code": "operable",
          "label": ["The account must permit business changes.", "账户需处于可操作状态。"],
          "remedies": ["human"]
        },
        {
          "code": "credits",
          "label": [
            "Available credits and the run ceiling must cover the next model reservation.",
            "可用积分与运行上限须足以预留下一次模型调用费用。"
          ],
          "remedies": ["human"]
        }
      ],
      "scope": "current_brand",
      "sources": "brand_fact_table"
    },
    "retry": {
      "backoff_seconds": 0,
      "max_attempts": 1
    },
    "stall_seconds": 600,
    "storage": "operations.output",
    "version": 1
  },
  {
    "cancel": "synchronous",
    "completion": "sync",
    "effects": "write",
    "errors": ["unauthorized", "not_found", "forbidden", "gated", "conflict", "bad_request"],
    "fee": "free",
    "id": "questions.confirm",
    "input_schema": {
      "additionalProperties": false,
      "properties": {
        "locale": {
          "type": "string"
        },
        "questions": {
          "items": {
            "additionalProperties": false,
            "properties": {
              "intent": {
                "type": "string"
              },
              "text": {
                "type": "string"
              }
            },
            "required": ["text", "intent"],
            "type": "object"
          },
          "type": "array"
        }
      },
      "required": ["locale", "questions"],
      "type": "object"
    },
    "label": ["Confirm tracked questions", "确认跟踪问题"],
    "output_schema": {
      "additionalProperties": false,
      "properties": {
        "questions": {
          "items": {
            "properties": {
              "id": {
                "type": "string"
              },
              "text": {
                "type": "string"
              }
            },
            "required": ["id", "text"],
            "type": "object"
          },
          "type": "array"
        },
        "set_id": {
          "type": "string"
        }
      },
      "required": ["set_id", "questions"],
      "type": "object"
    },
    "permission": "brand_edit",
    "requirements": {
      "locale": "input_locale",
      "period": "not_applicable",
      "prerequisites": [
        {
          "code": "permission",
          "label": ["Current brand editor access is required.", "需要当前品牌的编辑权限。"],
          "remedies": ["human"]
        },
        {
          "code": "operable",
          "label": ["The account must permit business changes.", "账户需处于可操作状态。"],
          "remedies": ["human"]
        },
        {
          "code": "explicit_questions",
          "label": [
            "Confirm the supplied candidates before enrolling paid sampling questions.",
            "确认提供的候选问题后，才能将其加入付费采样。"
          ],
          "remedies": ["questions.generate", "human"]
        }
      ],
      "scope": "current_brand",
      "sources": "scoped_database"
    },
    "retry": {
      "backoff_seconds": 0,
      "max_attempts": 1
    },
    "stall_seconds": 600,
    "storage": "question_sets, questions",
    "version": 1
  },
  {
    "cancel": "synchronous",
    "completion": "sync",
    "effects": "read",
    "errors": ["unauthorized", "not_found", "forbidden", "gated", "conflict", "bad_request"],
    "fee": "free",
    "id": "questions.read",
    "input_schema": {
      "additionalProperties": false,
      "properties": {
        "locale": {
          "type": "string"
        }
      },
      "required": ["locale"],
      "type": "object"
    },
    "label": ["Read questions", "读取问题集"],
    "output_schema": {
      "additionalProperties": false,
      "properties": {
        "questions": {
          "items": {
            "properties": {
              "id": {
                "type": "string"
              },
              "text": {
                "type": "string"
              }
            },
            "type": "object"
          },
          "type": "array"
        }
      },
      "required": ["questions"],
      "type": "object"
    },
    "permission": "read",
    "requirements": {
      "locale": "not_applicable",
      "period": "not_applicable",
      "prerequisites": [
        {
          "code": "permission",
          "label": ["Current brand read access is required.", "需要当前品牌的读取权限。"],
          "remedies": ["human"]
        }
      ],
      "scope": "current_brand",
      "sources": "scoped_database"
    },
    "retry": {
      "backoff_seconds": 0,
      "max_attempts": 1
    },
    "stall_seconds": 600,
    "storage": "questions",
    "version": 1
  },
  {
    "cancel": "synchronous",
    "completion": "sync",
    "effects": "read",
    "errors": ["unauthorized", "not_found", "forbidden", "gated", "conflict", "bad_request"],
    "fee": "free",
    "id": "favourability.analyse",
    "input_schema": {
      "additionalProperties": false,
      "properties": {
        "days": {
          "type": "integer"
        },
        "engine": {
          "type": "string"
        },
        "intent": {
          "type": "string"
        },
        "locale": {
          "type": "string"
        },
        "topics": {
          "items": {
            "type": "string"
          },
          "maxItems": 100,
          "type": "array"
        }
      },
      "required": ["locale", "days"],
      "type": "object"
    },
    "label": ["Analyse brand favourability", "分析品牌好感度"],
    "output_schema": {
      "additionalProperties": false,
      "properties": {
        "analysis": {
          "type": "object"
        }
      },
      "required": ["analysis"],
      "type": "object"
    },
    "permission": "read",
    "requirements": {
      "locale": "input_locale",
      "period": "input_window",
      "prerequisites": [
        {
          "code": "permission",
          "label": ["Current brand read access is required.", "需要当前品牌的读取权限。"],
          "remedies": ["human"]
        }
      ],
      "scope": "current_brand",
      "sources": "canonical_measurements"
    },
    "retry": {
      "backoff_seconds": 0,
      "max_attempts": 1
    },
    "stall_seconds": 600,
    "storage": "sample_mentions, claims",
    "version": 1
  },
  {
    "cancel": "synchronous",
    "completion": "sync",
    "effects": "read",
    "errors": ["unauthorized", "not_found", "forbidden", "gated", "conflict", "bad_request"],
    "fee": "free",
    "id": "draft.validate",
    "input_schema": {
      "additionalProperties": false,
      "properties": {
        "page_id": {
          "type": "string"
        },
        "revision": {
          "type": "integer"
        }
      },
      "required": ["page_id", "revision"],
      "type": "object"
    },
    "label": ["Validate edited draft revision", "校验人工修订草稿"],
    "output_schema": {
      "additionalProperties": false,
      "properties": {
        "page_id": {
          "type": "string"
        },
        "revision": {
          "type": "integer"
        },
        "valid": {
          "type": "boolean"
        }
      },
      "required": ["page_id", "revision", "valid"],
      "type": "object"
    },
    "permission": "read",
    "requirements": {
      "locale": "not_applicable",
      "period": "not_applicable",
      "prerequisites": [
        {
          "code": "permission",
          "label": ["Current brand read access is required.", "需要当前品牌的读取权限。"],
          "remedies": ["human"]
        },
        {
          "code": "page_revision",
          "label": [
            "Use this brand's stored page and its current working revision.",
            "使用当前品牌的已保存页面及其当前工作修订。"
          ],
          "remedies": ["draft.generate", "draft.read", "human"]
        }
      ],
      "scope": "current_brand",
      "sources": "stored_page_revision"
    },
    "retry": {
      "backoff_seconds": 0,
      "max_attempts": 1
    },
    "stall_seconds": 600,
    "storage": "pages, page_revisions",
    "version": 1
  },
  {
    "cancel": "synchronous",
    "completion": "sync",
    "effects": "read",
    "errors": ["unauthorized", "not_found", "forbidden", "gated", "conflict", "bad_request"],
    "fee": "free",
    "id": "draft.read",
    "input_schema": {
      "additionalProperties": false,
      "properties": {
        "page_id": {
          "type": "string"
        }
      },
      "required": ["page_id"],
      "type": "object"
    },
    "label": ["Read draft status", "读取草稿状态"],
    "output_schema": {
      "additionalProperties": false,
      "properties": {
        "blocks": {},
        "page_id": {
          "type": "string"
        },
        "revision": {
          "type": "integer"
        },
        "status": {
          "type": "string"
        },
        "title": {
          "type": "string"
        }
      },
      "required": ["page_id", "status", "revision"],
      "type": "object"
    },
    "permission": "read",
    "requirements": {
      "locale": "not_applicable",
      "period": "not_applicable",
      "prerequisites": [
        {
          "code": "permission",
          "label": ["Current brand read access is required.", "需要当前品牌的读取权限。"],
          "remedies": ["human"]
        },
        {
          "code": "page_revision",
          "label": [
            "Use this brand's stored page and its current working revision.",
            "使用当前品牌的已保存页面及其当前工作修订。"
          ],
          "remedies": ["draft.generate", "draft.read", "human"]
        }
      ],
      "scope": "current_brand",
      "sources": "stored_page_revision"
    },
    "retry": {
      "backoff_seconds": 0,
      "max_attempts": 1
    },
    "stall_seconds": 600,
    "storage": "pages",
    "version": 1
  },
  {
    "cancel": "drain_in_flight",
    "completion": "job",
    "effects": "write",
    "errors": ["unauthorized", "not_found", "forbidden", "gated", "conflict", "bad_request"],
    "fee": "metered",
    "id": "samples.collect",
    "input_schema": {
      "additionalProperties": false,
      "properties": {
        "locale": {
          "type": "string"
        },
        "persona_id": {
          "type": "string"
        },
        "question_ids": {
          "items": {
            "type": "string"
          },
          "type": "array"
        }
      },
      "required": ["locale"],
      "type": "object"
    },
    "label": ["Collect answer batches", "采集回答批次"],
    "output_schema": {
      "additionalProperties": false,
      "properties": {
        "batches": {
          "items": {
            "properties": {
              "batch_id": {
                "type": "string"
              },
              "engine": {
                "type": "string"
              },
              "failed": {
                "type": "integer"
              },
              "stored": {
                "type": "integer"
              }
            },
            "required": ["batch_id", "engine", "stored", "failed"],
            "type": "object"
          },
          "type": "array"
        }
      },
      "required": ["batches"],
      "type": "object"
    },
    "permission": "brand_edit",
    "requirements": {
      "locale": "input_locale",
      "period": "not_applicable",
      "prerequisites": [
        {
          "code": "permission",
          "label": ["Current brand editor access is required.", "需要当前品牌的编辑权限。"],
          "remedies": ["human"]
        },
        {
          "code": "operable",
          "label": ["The account must permit business changes.", "账户需处于可操作状态。"],
          "remedies": ["human"]
        },
        {
          "code": "credits",
          "label": [
            "Available credits and the run ceiling must cover the next model reservation.",
            "可用积分与运行上限须足以预留下一次模型调用费用。"
          ],
          "remedies": ["human"]
        },
        {
          "code": "paid_sampling",
          "label": [
            "Sampling requires an active paid plan and enabled questions in the selected language.",
            "采样需要有效付费套餐及所选语言的已启用问题。"
          ],
          "remedies": ["questions.generate", "questions.confirm", "human"]
        }
      ],
      "scope": "current_brand",
      "sources": "confirmed_questions"
    },
    "retry": {
      "backoff_seconds": 0,
      "max_attempts": 1
    },
    "stall_seconds": 900,
    "storage": "sample_batches, samples, sample_citations, sample_mentions",
    "version": 1
  },
  {
    "cancel": "synchronous",
    "completion": "sync",
    "effects": "read",
    "errors": ["unauthorized", "not_found", "forbidden", "gated", "conflict", "bad_request"],
    "fee": "free",
    "id": "samples.read",
    "input_schema": {
      "additionalProperties": false,
      "properties": {
        "after_id": {
          "type": "string"
        },
        "batch_id": {
          "type": "string"
        }
      },
      "required": ["batch_id"],
      "type": "object"
    },
    "label": ["Read batch answers", "读取批次回答"],
    "output_schema": {
      "additionalProperties": false,
      "properties": {
        "answers": {
          "items": {
            "type": "object"
          },
          "type": "array"
        },
        "batch_id": {
          "type": "string"
        },
        "next_after_id": {
          "type": "string"
        },
        "status": {
          "type": "string"
        }
      },
      "required": ["batch_id", "status", "answers"],
      "type": "object"
    },
    "permission": "read",
    "requirements": {
      "locale": "input_locale",
      "period": "explicit_or_latest_batch",
      "prerequisites": [
        {
          "code": "permission",
          "label": ["Current brand read access is required.", "需要当前品牌的读取权限。"],
          "remedies": ["human"]
        }
      ],
      "scope": "current_brand",
      "sources": "scoped_sample_batches"
    },
    "retry": {
      "backoff_seconds": 0,
      "max_attempts": 1
    },
    "stall_seconds": 600,
    "storage": "sample_batches, samples",
    "version": 1
  },
  {
    "cancel": "synchronous",
    "completion": "sync",
    "effects": "read",
    "errors": ["unauthorized", "not_found", "forbidden", "gated", "conflict", "bad_request"],
    "fee": "free",
    "id": "regions.read",
    "input_schema": {
      "additionalProperties": false,
      "properties": {
        "days": {
          "maximum": 365,
          "minimum": 1,
          "type": "integer"
        },
        "engine": {
          "type": "string"
        },
        "intent": {
          "type": "string"
        },
        "locale": {
          "type": "string"
        },
        "topics": {
          "items": {
            "type": "string"
          },
          "type": "array"
        }
      },
      "required": ["locale", "days"],
      "type": "object"
    },
    "label": ["Read regional performance", "读取地区表现"],
    "output_schema": {
      "additionalProperties": false,
      "properties": {
        "analysis": {
          "type": "object"
        }
      },
      "required": ["analysis"],
      "type": "object"
    },
    "permission": "read",
    "requirements": {
      "locale": "input_locale",
      "period": "input_window",
      "prerequisites": [
        {
          "code": "permission",
          "label": ["Current brand read access is required.", "需要当前品牌的读取权限。"],
          "remedies": ["human"]
        }
      ],
      "scope": "current_brand",
      "sources": "canonical_measurements"
    },
    "retry": {
      "backoff_seconds": 0,
      "max_attempts": 1
    },
    "stall_seconds": 600,
    "storage": "samples, insight_audiences",
    "version": 1
  },
  {
    "cancel": "synchronous",
    "completion": "sync",
    "effects": "read",
    "errors": ["unauthorized", "not_found", "forbidden", "gated", "conflict", "bad_request"],
    "fee": "free",
    "id": "personas.read",
    "input_schema": {
      "additionalProperties": false,
      "properties": {
        "days": {
          "maximum": 365,
          "minimum": 1,
          "type": "integer"
        },
        "engine": {
          "type": "string"
        },
        "intent": {
          "type": "string"
        },
        "locale": {
          "type": "string"
        },
        "topics": {
          "items": {
            "type": "string"
          },
          "type": "array"
        }
      },
      "required": ["locale", "days"],
      "type": "object"
    },
    "label": ["Read persona performance", "读取客户角色表现"],
    "output_schema": {
      "additionalProperties": false,
      "properties": {
        "analysis": {
          "type": "object"
        }
      },
      "required": ["analysis"],
      "type": "object"
    },
    "permission": "read",
    "requirements": {
      "locale": "input_locale",
      "period": "input_window",
      "prerequisites": [
        {
          "code": "permission",
          "label": ["Current brand read access is required.", "需要当前品牌的读取权限。"],
          "remedies": ["human"]
        }
      ],
      "scope": "current_brand",
      "sources": "canonical_measurements"
    },
    "retry": {
      "backoff_seconds": 0,
      "max_attempts": 1
    },
    "stall_seconds": 600,
    "storage": "samples, insight_audiences",
    "version": 1
  },
  {
    "cancel": "synchronous",
    "completion": "sync",
    "effects": "read",
    "errors": ["unauthorized", "not_found", "forbidden", "gated", "conflict", "bad_request"],
    "fee": "free",
    "id": "platforms.read",
    "input_schema": {
      "additionalProperties": false,
      "properties": {
        "days": {
          "maximum": 365,
          "minimum": 1,
          "type": "integer"
        },
        "engine": {
          "type": "string"
        },
        "intent": {
          "type": "string"
        },
        "locale": {
          "type": "string"
        },
        "topics": {
          "items": {
            "type": "string"
          },
          "type": "array"
        }
      },
      "required": ["locale", "days"],
      "type": "object"
    },
    "label": ["Read platform performance", "读取平台表现"],
    "output_schema": {
      "additionalProperties": false,
      "properties": {
        "analysis": {
          "type": "object"
        }
      },
      "required": ["analysis"],
      "type": "object"
    },
    "permission": "read",
    "requirements": {
      "locale": "input_locale",
      "period": "input_window",
      "prerequisites": [
        {
          "code": "permission",
          "label": ["Current brand read access is required.", "需要当前品牌的读取权限。"],
          "remedies": ["human"]
        }
      ],
      "scope": "current_brand",
      "sources": "canonical_measurements"
    },
    "retry": {
      "backoff_seconds": 0,
      "max_attempts": 1
    },
    "stall_seconds": 600,
    "storage": "samples, insight_audiences",
    "version": 1
  },
  {
    "cancel": "synchronous",
    "completion": "sync",
    "effects": "write",
    "errors": ["unauthorized", "not_found", "forbidden", "gated", "conflict", "bad_request"],
    "fee": "free",
    "id": "audiences.save",
    "input_schema": {
      "additionalProperties": false,
      "properties": {
        "archived": {
          "type": "boolean"
        },
        "id": {
          "type": "string"
        },
        "kind": {
          "enum": ["region", "persona"],
          "type": "string"
        },
        "name": {
          "maxLength": 100,
          "minLength": 1,
          "type": "string"
        },
        "profile": {
          "type": "object"
        },
        "question_ids": {
          "items": {
            "type": "string"
          },
          "type": "array"
        },
        "topics": {
          "items": {
            "type": "string"
          },
          "type": "array"
        }
      },
      "required": ["kind", "name", "profile", "topics", "question_ids"],
      "type": "object"
    },
    "label": ["Configure region or persona", "配置地区或客户角色"],
    "output_schema": {
      "additionalProperties": false,
      "properties": {
        "id": {
          "type": "string"
        }
      },
      "required": ["id"],
      "type": "object"
    },
    "permission": "brand_edit",
    "requirements": {
      "locale": "not_applicable",
      "period": "not_applicable",
      "prerequisites": [
        {
          "code": "permission",
          "label": ["Current brand editor access is required.", "需要当前品牌的编辑权限。"],
          "remedies": ["human"]
        },
        {
          "code": "operable",
          "label": ["The account must permit business changes.", "账户需处于可操作状态。"],
          "remedies": ["human"]
        }
      ],
      "scope": "current_brand",
      "sources": "scoped_database"
    },
    "retry": {
      "backoff_seconds": 0,
      "max_attempts": 1
    },
    "stall_seconds": 600,
    "storage": "insight_audiences",
    "version": 1
  },
  {
    "cancel": "synchronous",
    "completion": "sync",
    "effects": "read",
    "errors": ["unauthorized", "not_found", "forbidden", "gated", "conflict", "bad_request"],
    "fee": "free",
    "id": "metrics.read",
    "input_schema": {
      "additionalProperties": false,
      "properties": {
        "days": {
          "type": "integer"
        },
        "engine": {
          "type": "string"
        },
        "intent": {
          "type": "string"
        },
        "locale": {
          "type": "string"
        },
        "topics": {
          "items": {
            "type": "string"
          },
          "maxItems": 100,
          "type": "array"
        }
      },
      "required": ["locale", "days"],
      "type": "object"
    },
    "label": ["Read metrics and comparison", "读取指标与对比"],
    "output_schema": {
      "additionalProperties": false,
      "properties": {
        "metrics": {
          "items": {
            "properties": {
              "current": {
                "properties": {
                  "value": {
                    "type": "number"
                  }
                },
                "type": "object"
              },
              "metric": {
                "type": "string"
              },
              "previous": {
                "properties": {
                  "value": {
                    "type": "number"
                  }
                },
                "type": "object"
              }
            },
            "required": ["metric", "current", "previous"],
            "type": "object"
          },
          "type": "array"
        },
        "previous_samples": {
          "type": "integer"
        },
        "samples": {
          "type": "integer"
        }
      },
      "required": ["samples", "previous_samples", "metrics"],
      "type": "object"
    },
    "permission": "read",
    "requirements": {
      "locale": "input_locale",
      "period": "input_window",
      "prerequisites": [
        {
          "code": "permission",
          "label": ["Current brand read access is required.", "需要当前品牌的读取权限。"],
          "remedies": ["human"]
        }
      ],
      "scope": "current_brand",
      "sources": "canonical_measurements"
    },
    "retry": {
      "backoff_seconds": 0,
      "max_attempts": 1
    },
    "stall_seconds": 600,
    "storage": "samples, sample_mentions, sample_citations",
    "version": 1
  },
  {
    "cancel": "synchronous",
    "completion": "sync",
    "effects": "read",
    "errors": ["unauthorized", "not_found", "forbidden", "gated", "conflict", "bad_request"],
    "fee": "free",
    "id": "opportunities.read",
    "input_schema": {
      "additionalProperties": false,
      "properties": {
        "locale": {
          "type": "string"
        }
      },
      "required": ["locale"],
      "type": "object"
    },
    "label": ["Read opportunity reports", "读取机会报告"],
    "output_schema": {
      "additionalProperties": false,
      "properties": {
        "reports": {
          "items": {
            "type": "object"
          },
          "type": "array"
        }
      },
      "required": ["reports"],
      "type": "object"
    },
    "permission": "read",
    "requirements": {
      "locale": "input_locale",
      "period": "not_applicable",
      "prerequisites": [
        {
          "code": "permission",
          "label": ["Current brand read access is required.", "需要当前品牌的读取权限。"],
          "remedies": ["human"]
        },
        {
          "code": "advanced_plan",
          "label": ["The current plan must include advanced insights.", "当前套餐需包含高级分析。"],
          "remedies": ["human"]
        }
      ],
      "scope": "current_brand",
      "sources": "stored_content_evidence"
    },
    "retry": {
      "backoff_seconds": 0,
      "max_attempts": 1
    },
    "stall_seconds": 600,
    "storage": "entity_opportunities",
    "version": 1
  },
  {
    "cancel": "synchronous",
    "completion": "sync",
    "effects": "read",
    "errors": ["unauthorized", "not_found", "forbidden", "gated", "conflict", "bad_request"],
    "fee": "free",
    "id": "brief.generate",
    "input_schema": {
      "additionalProperties": false,
      "properties": {
        "gap_id": {
          "type": "string"
        },
        "locale": {
          "type": "string"
        },
        "other_entity_id": {
          "type": "string"
        },
        "recipe": {
          "type": "string"
        }
      },
      "required": ["recipe", "locale"],
      "type": "object"
    },
    "label": ["Assemble sourced brief", "组装有来源的简报"],
    "output_schema": {
      "additionalProperties": false,
      "properties": {
        "brief": {
          "type": "object"
        },
        "sources": {
          "items": {
            "type": "string"
          },
          "type": "array"
        }
      },
      "required": ["brief", "sources"],
      "type": "object"
    },
    "permission": "read",
    "requirements": {
      "locale": "input_locale",
      "period": "not_applicable",
      "prerequisites": [
        {
          "code": "permission",
          "label": ["Current brand read access is required.", "需要当前品牌的读取权限。"],
          "remedies": ["human"]
        }
      ],
      "scope": "current_brand",
      "sources": "brand_fact_table"
    },
    "retry": {
      "backoff_seconds": 0,
      "max_attempts": 1
    },
    "stall_seconds": 600,
    "storage": "entities, samples",
    "version": 1
  },
  {
    "cancel": "drain_in_flight",
    "completion": "job",
    "effects": "write",
    "errors": ["unauthorized", "not_found", "forbidden", "gated", "conflict", "bad_request"],
    "fee": "free",
    "id": "reflow.compare",
    "input_schema": {
      "additionalProperties": false,
      "properties": {
        "after_batches": {
          "items": {
            "properties": {
              "batch_id": {
                "type": "string"
              }
            },
            "required": ["batch_id"],
            "type": "object"
          },
          "type": "array"
        },
        "before_batches": {
          "items": {
            "properties": {
              "batch_id": {
                "type": "string"
              }
            },
            "required": ["batch_id"],
            "type": "object"
          },
          "type": "array"
        },
        "page_id": {
          "type": "string"
        },
        "revision": {
          "type": "integer"
        }
      },
      "required": ["page_id", "revision", "before_batches", "after_batches"],
      "type": "object"
    },
    "label": ["Compare publication cohorts", "对比发布前后批次"],
    "output_schema": {
      "additionalProperties": false,
      "properties": {
        "comparison": {
          "type": "object"
        },
        "reflow_id": {
          "type": "string"
        }
      },
      "required": ["reflow_id", "comparison"],
      "type": "object"
    },
    "permission": "brand_edit",
    "requirements": {
      "locale": "not_applicable",
      "period": "explicit_before_after_batches",
      "prerequisites": [
        {
          "code": "permission",
          "label": ["Current brand editor access is required.", "需要当前品牌的编辑权限。"],
          "remedies": ["human"]
        },
        {
          "code": "operable",
          "label": ["The account must permit business changes.", "账户需处于可操作状态。"],
          "remedies": ["human"]
        },
        {
          "code": "observation",
          "label": [
            "Use explicit before/after batches and the observed publication revision; incomplete or small cohorts cannot prove an effect.",
            "使用明确的前后批次与被观察的发布修订；未完成或过小的样本不能证明效果。"
          ],
          "remedies": ["page.publish", "wait", "samples.collect"]
        }
      ],
      "scope": "current_brand",
      "sources": "completed_sample_batches"
    },
    "retry": {
      "backoff_seconds": 0,
      "max_attempts": 1
    },
    "stall_seconds": 1200,
    "storage": "reflows",
    "version": 1
  },
  {
    "cancel": "synchronous",
    "completion": "sync",
    "effects": "read",
    "errors": ["unauthorized", "not_found", "forbidden", "gated", "conflict", "bad_request"],
    "fee": "free",
    "id": "reflow.read",
    "input_schema": {
      "additionalProperties": false,
      "properties": {
        "page_id": {
          "type": "string"
        }
      },
      "required": ["page_id"],
      "type": "object"
    },
    "label": ["Read reflow comparison", "读取回流对比"],
    "output_schema": {
      "additionalProperties": false,
      "properties": {
        "page_id": {
          "type": "string"
        },
        "reports": {
          "items": {
            "type": "object"
          },
          "type": "array"
        }
      },
      "required": ["page_id", "reports"],
      "type": "object"
    },
    "permission": "read",
    "requirements": {
      "locale": "input_locale",
      "period": "input_window",
      "prerequisites": [
        {
          "code": "permission",
          "label": ["Current brand read access is required.", "需要当前品牌的读取权限。"],
          "remedies": ["human"]
        }
      ],
      "scope": "current_brand",
      "sources": "canonical_measurements"
    },
    "retry": {
      "backoff_seconds": 0,
      "max_attempts": 1
    },
    "stall_seconds": 600,
    "storage": "reflows",
    "version": 1
  },
  {
    "cancel": "synchronous",
    "completion": "sync",
    "effects": "read",
    "errors": ["unauthorized", "not_found", "forbidden", "gated", "conflict", "bad_request"],
    "fee": "free",
    "id": "reflow.due",
    "input_schema": {
      "additionalProperties": false,
      "properties": {
        "locale": {
          "type": "string"
        },
        "observation_days": {
          "maximum": 90,
          "minimum": 14,
          "type": "integer"
        }
      },
      "required": ["locale"],
      "type": "object"
    },
    "label": ["Find pages due for comparison", "查找到期待对比的页面"],
    "output_schema": {
      "additionalProperties": false,
      "properties": {
        "pages": {
          "items": {
            "properties": {
              "after_batches": {
                "items": {
                  "properties": {
                    "batch_id": {
                      "type": "string"
                    }
                  },
                  "required": ["batch_id"],
                  "type": "object"
                },
                "type": "array"
              },
              "before_batches": {
                "items": {
                  "properties": {
                    "batch_id": {
                      "type": "string"
                    }
                  },
                  "required": ["batch_id"],
                  "type": "object"
                },
                "type": "array"
              },
              "page_id": {
                "type": "string"
              },
              "published_at": {
                "type": "string"
              },
              "revision": {
                "type": "integer"
              }
            },
            "required": ["page_id", "revision", "published_at", "before_batches", "after_batches"],
            "type": "object"
          },
          "type": "array"
        }
      },
      "required": ["pages"],
      "type": "object"
    },
    "permission": "read",
    "requirements": {
      "locale": "not_applicable",
      "period": "not_applicable",
      "prerequisites": [
        {
          "code": "permission",
          "label": ["Current brand read access is required.", "需要当前品牌的读取权限。"],
          "remedies": ["human"]
        }
      ],
      "scope": "current_brand",
      "sources": "scoped_database"
    },
    "retry": {
      "backoff_seconds": 0,
      "max_attempts": 1
    },
    "stall_seconds": 600,
    "storage": "pages, sample_batches",
    "version": 1
  },
  {
    "cancel": "synchronous",
    "completion": "sync",
    "effects": "read",
    "errors": ["unauthorized", "not_found", "forbidden", "gated", "conflict", "bad_request"],
    "fee": "free",
    "id": "review.pending",
    "input_schema": {
      "additionalProperties": false,
      "properties": {
        "locale": {
          "type": "string"
        }
      },
      "required": ["locale"],
      "type": "object"
    },
    "label": ["Find drafts awaiting review", "查找待审核草稿"],
    "output_schema": {
      "additionalProperties": false,
      "properties": {
        "pages": {
          "items": {
            "properties": {
              "page_id": {
                "type": "string"
              },
              "revision": {
                "type": "integer"
              },
              "title": {
                "type": "string"
              }
            },
            "required": ["page_id", "revision", "title"],
            "type": "object"
          },
          "type": "array"
        }
      },
      "required": ["pages"],
      "type": "object"
    },
    "permission": "read",
    "requirements": {
      "locale": "not_applicable",
      "period": "not_applicable",
      "prerequisites": [
        {
          "code": "permission",
          "label": ["Current brand read access is required.", "需要当前品牌的读取权限。"],
          "remedies": ["human"]
        }
      ],
      "scope": "current_brand",
      "sources": "scoped_database"
    },
    "retry": {
      "backoff_seconds": 0,
      "max_attempts": 1
    },
    "stall_seconds": 600,
    "storage": "pages, page_revisions",
    "version": 1
  },
  {
    "cancel": "drain_in_flight",
    "completion": "job",
    "effects": "write",
    "errors": ["unauthorized", "not_found", "forbidden", "gated", "conflict", "bad_request"],
    "fee": "free",
    "id": "page.publish",
    "input_schema": {
      "additionalProperties": false,
      "properties": {
        "before_batches": {
          "items": {
            "properties": {
              "batch_id": {
                "type": "string"
              }
            },
            "required": ["batch_id"],
            "type": "object"
          },
          "type": "array"
        },
        "block_dirty_facts": {
          "type": "boolean"
        },
        "locale": {
          "type": "string"
        },
        "page_id": {
          "type": "string"
        },
        "revision": {
          "type": "integer"
        }
      },
      "required": ["page_id", "revision"],
      "type": "object"
    },
    "label": ["Publish approved page revision", "发布指定页面版本"],
    "output_schema": {
      "additionalProperties": false,
      "properties": {
        "page_id": {
          "type": "string"
        },
        "revalidated": {
          "items": {
            "type": "string"
          },
          "type": "array"
        },
        "revision": {
          "type": "integer"
        },
        "status": {
          "type": "string"
        }
      },
      "required": ["page_id", "revision", "status", "revalidated"],
      "type": "object"
    },
    "permission": "brand_edit",
    "requirements": {
      "locale": "not_applicable",
      "period": "not_applicable",
      "prerequisites": [
        {
          "code": "permission",
          "label": ["Current brand editor access is required.", "需要当前品牌的编辑权限。"],
          "remedies": ["human"]
        },
        {
          "code": "operable",
          "label": ["The account must permit business changes.", "账户需处于可操作状态。"],
          "remedies": ["human"]
        },
        {
          "code": "page_revision",
          "label": [
            "Use this brand's stored page and its current working revision.",
            "使用当前品牌的已保存页面及其当前工作修订。"
          ],
          "remedies": ["draft.generate", "draft.read", "human"]
        },
        {
          "code": "approval",
          "label": [
            "A workflow needs explicit automatic-publication authorization or human approval for this revision.",
            "工作流需获得明确自动发布授权，或对此修订的人工批准。"
          ],
          "remedies": ["human"]
        },
        {
          "code": "factcheck_policy",
          "label": [
            "When clean checks are required, the exact baseline batches must remain completely checked against current facts.",
            "启用事实检查要求时，指定基线批次必须完整且按当前事实检查通过。"
          ],
          "remedies": ["claims.check", "workflow.readiness", "human"]
        }
      ],
      "scope": "current_brand",
      "sources": "stored_page_revision"
    },
    "retry": {
      "backoff_seconds": 0,
      "max_attempts": 1
    },
    "stall_seconds": 600,
    "storage": "pages, page_revisions",
    "version": 1
  },
  {
    "cancel": "drain_in_flight",
    "completion": "job",
    "effects": "write",
    "errors": ["unauthorized", "not_found", "forbidden", "gated", "conflict", "bad_request"],
    "fee": "metered",
    "id": "draft.generate",
    "input_schema": {
      "additionalProperties": false,
      "properties": {
        "daily": {
          "type": "boolean"
        },
        "gap_id": {
          "type": "string"
        },
        "locale": {
          "type": "string"
        },
        "other_entity_id": {
          "type": "string"
        },
        "quality": {
          "type": "string"
        },
        "recipe": {
          "type": "string"
        },
        "template_id": {
          "type": "string"
        }
      },
      "required": ["recipe", "locale", "quality"],
      "type": "object"
    },
    "label": ["Generate draft", "生成草稿"],
    "output_schema": {
      "additionalProperties": false,
      "properties": {
        "cost_micros": {
          "type": "integer"
        },
        "page_id": {
          "type": "string"
        },
        "removed": {
          "type": "integer"
        },
        "revision": {
          "type": "integer"
        },
        "status": {
          "type": "string"
        }
      },
      "required": ["page_id", "status"],
      "type": "object"
    },
    "permission": "brand_edit",
    "requirements": {
      "locale": "input_locale",
      "period": "not_applicable",
      "prerequisites": [
        {
          "code": "permission",
          "label": ["Current brand editor access is required.", "需要当前品牌的编辑权限。"],
          "remedies": ["human"]
        },
        {
          "code": "operable",
          "label": ["The account must permit business changes.", "账户需处于可操作状态。"],
          "remedies": ["human"]
        },
        {
          "code": "credits",
          "label": [
            "Available credits and the run ceiling must cover the next model reservation.",
            "可用积分与运行上限须足以预留下一次模型调用费用。"
          ],
          "remedies": ["human"]
        }
      ],
      "scope": "current_brand",
      "sources": "brand_fact_table"
    },
    "retry": {
      "backoff_seconds": 0,
      "max_attempts": 1
    },
    "stall_seconds": 1800,
    "storage": "pages, page_revisions",
    "version": 1
  },
  {
    "cancel": "drain_in_flight",
    "completion": "job",
    "effects": "write",
    "errors": ["unauthorized", "not_found", "forbidden", "gated", "conflict", "bad_request"],
    "fee": "metered",
    "id": "opportunities.generate",
    "input_schema": {
      "additionalProperties": false,
      "properties": {
        "locale": {
          "type": "string"
        }
      },
      "required": ["locale"],
      "type": "object"
    },
    "label": ["Generate opportunity report", "生成机会报告"],
    "output_schema": {
      "additionalProperties": false,
      "properties": {
        "opportunities": {
          "type": "integer"
        },
        "report": {
          "type": "object"
        }
      },
      "required": ["opportunities", "report"],
      "type": "object"
    },
    "permission": "brand_edit",
    "requirements": {
      "locale": "input_locale",
      "period": "recent_30_days",
      "prerequisites": [
        {
          "code": "permission",
          "label": ["Current brand editor access is required.", "需要当前品牌的编辑权限。"],
          "remedies": ["human"]
        },
        {
          "code": "operable",
          "label": ["The account must permit business changes.", "账户需处于可操作状态。"],
          "remedies": ["human"]
        },
        {
          "code": "credits",
          "label": [
            "Available credits and the run ceiling must cover the next model reservation.",
            "可用积分与运行上限须足以预留下一次模型调用费用。"
          ],
          "remedies": ["human"]
        },
        {
          "code": "advanced_plan",
          "label": ["The current plan must include advanced insights.", "当前套餐需包含高级分析。"],
          "remedies": ["human"]
        },
        {
          "code": "answers",
          "label": [
            "At least five usable answers are needed; an empty sample cannot support an opportunity report.",
            "至少需要五条可用回答；空样本不能支持机会报告。"
          ],
          "remedies": ["samples.collect", "human"]
        }
      ],
      "scope": "current_brand",
      "sources": "scoped_database"
    },
    "retry": {
      "backoff_seconds": 0,
      "max_attempts": 1
    },
    "stall_seconds": 1800,
    "storage": "entity_opportunities",
    "version": 1
  },
  {
    "cancel": "drain_in_flight",
    "completion": "job",
    "effects": "write",
    "errors": ["unauthorized", "not_found", "forbidden", "gated", "conflict", "bad_request"],
    "fee": "metered",
    "id": "claims.check",
    "input_schema": {
      "additionalProperties": false,
      "properties": {
        "batches": {
          "items": {
            "properties": {
              "batch_id": {
                "type": "string"
              }
            },
            "required": ["batch_id"],
            "type": "object"
          },
          "type": "array"
        },
        "locale": {
          "type": "string"
        }
      },
      "required": [],
      "type": "object"
    },
    "label": ["Extract and check claims", "抽取并检查声明"],
    "output_schema": {
      "additionalProperties": false,
      "properties": {
        "checked": {
          "type": "integer"
        },
        "cost_micros": {
          "type": "integer"
        },
        "found": {
          "type": "integer"
        }
      },
      "required": ["checked", "found"],
      "type": "object"
    },
    "permission": "brand_edit",
    "requirements": {
      "locale": "input_locale",
      "period": "not_applicable",
      "prerequisites": [
        {
          "code": "permission",
          "label": ["Current brand editor access is required.", "需要当前品牌的编辑权限。"],
          "remedies": ["human"]
        },
        {
          "code": "operable",
          "label": ["The account must permit business changes.", "账户需处于可操作状态。"],
          "remedies": ["human"]
        },
        {
          "code": "credits",
          "label": [
            "Available credits and the run ceiling must cover the next model reservation.",
            "可用积分与运行上限须足以预留下一次模型调用费用。"
          ],
          "remedies": ["human"]
        },
        {
          "code": "sourced_facts",
          "label": [
            "Claims are checked against the brand's facts; a brand with none has nothing to check.",
            "声明依据品牌事实检查；没有事实的品牌无从检查。"
          ],
          "remedies": ["brand.supplement", "facts.source", "human"]
        }
      ],
      "scope": "current_brand",
      "sources": "brand_fact_table"
    },
    "retry": {
      "backoff_seconds": 0,
      "max_attempts": 1
    },
    "stall_seconds": 1800,
    "storage": "claims, sample_factchecks",
    "version": 1
  }
]
